import { useState } from "react";
import { Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

type InfoPopupButtonProps = {
  title: string;
  description: string;
  /** Accessible label for the trigger; defaults to title */
  ariaLabel?: string;
  className?: string;
  iconClassName?: string;
};

/** Small info (i) button that opens a dialog with title + description. */
export function InfoPopupButton({
  title,
  description,
  ariaLabel,
  className,
  iconClassName,
}: InfoPopupButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className={cn(
          "shrink-0 rounded-full p-0.5 text-muted-foreground hover:text-foreground hover:bg-muted/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          className,
        )}
        aria-label={ariaLabel ?? title}
      >
        <Info className={cn("h-3.5 w-3.5", iconClassName)} />
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription className="text-sm leading-relaxed pt-1">
              {description}
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
